<template lang="pug">
div
  active-item
    .vue-dropdown.vue-dropdown--mobile.border-solid.border-primary.border-2(:class="{ active: active }" slot-scope="{ setActive, active }" v-click-outside="() => setActive(false)")
      .form-icon-wrapper.form-icon-wrapper--left(v-bind:class="{ reversearrow: active  }")
        .vue-dropdown__btn.flex.justify-between(@click.prevent="setActive(!active)")
          .border-b-s.cursor-pointer {{ priceRange }}
      .vue-dropdown__menu.p-2(v-show="active")
        .vue-dropdown__menu__group.flex.items-center(v-for="(label, value) in placePrices" :key="value" )
          p-check(:value="value" v-model="checkedPrices" @change.native="$emit('input', checkedPrices)")
            | {{ label['label'] }}
</template>

<script>
export default {

  props: {
    placePrices: {
      type: Array,
      required: true
    },

    value: {
      type: Array,
      required: true
    },

    translations: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      checkedPrices: this.value || []
    }
  },

  computed: {
    priceRange () {
      if (this.checkedPrices.length < 1) {
        return this.translations.pricepicker
      }

      return this.checkedPrices.map(x => this.placePrices[x].label).join(', ')
    }
  }
}
</script>
